import { EntityRoutes } from 'routes/constants';
import { DateFormats } from 'UI/constants/defaults';
import { ENTITY_TYPE_ID_MAP } from 'UI/constants/entityTypes';

export const TABLE_KEY = 'archived-actions';

export const ContactRoutes = {
  [ENTITY_TYPE_ID_MAP.candidate]: EntityRoutes.CandidateProfile,
  [ENTITY_TYPE_ID_MAP.company]: EntityRoutes.CompanyProfile,
  [ENTITY_TYPE_ID_MAP.hiringAuthority]: EntityRoutes.HiringAuthorityProfile,
  [ENTITY_TYPE_ID_MAP.contact]: EntityRoutes.ContactProfile
};

export const ARCHIVED_ACTIONS_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'roleId',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'taskStatus',
    label: 'Action Status',
    options: {
      filter: true,
      display: true,
      renderer: 'taskStatus'
    }
  },
  {
    name: 'taskType',
    label: 'Action Type',
    options: {
      filter: true,
      display: true,
      setCellHeaderProps: () => ({
        style: { minWidth: 150 }
      })
    }
  },
  {
    name: 'archivedAt',
    label: 'Archived at',
    options: {
      filter: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: {
          format: DateFormats.MonthDayYearTime
        }
      }
    }
  },
  {
    name: 'daysToBeDeleted',
    label: 'Days Before Deletion',
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: 'startDate',
    label: 'Date & Time',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'contact',
    label: 'Reach Out to',
    options: {
      sort: true,
      display: true,
      renderer: 'contactLink'
    }
  },
  {
    name: 'entity',
    label: 'Contact Type',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'contactStatus',
    label: 'Contact Status',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'candidateType',
    label: 'Candidate Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'companyType',
    label: 'Company Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'company',
    label: 'Company',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          idKey: 'id',
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'createdAt',
    label: 'Created on',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: { format: DateFormats.MonthDayYearTime }
      }
    }
  },
  {
    name: 'updatedAt',
    label: 'Last Updated on',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: { format: DateFormats.MonthDayYearTime }
      }
    }
  },
  {
    name: 'lastCommentAt',
    label: 'Last Comment on',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: { format: DateFormats.MonthDayYearTime }
      }
    }
  },
  {
    name: 'createdByName',
    label: 'Created by',
    options: {
      sort: true,
      display: true
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'archivedAt',
  direction: 'desc'
};
